import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import UpgradeConfirmationView from 'components/UpgradeConfirmationView/UpgradeConfirmationView.jsx'

import upgradeBuilding, { closeUpgradeConfirmation } from 'state/actions/building_upgrade'
import { BUILDING_TITLES } from 'helpers/i18n.jsx'

export class UpgradeConfirmation extends React.Component {
    static propTypes = {
        building: PropTypes.shape({
            id: PropTypes.number.isRequired,
            type: PropTypes.string.isRequired,
            level: PropTypes.number.isRequired,
        }).isRequired,
        upgraded: PropTypes.bool.isRequired,
        upgradeCost: PropTypes.number.isRequired,
        upgradeBuilding: PropTypes.func.isRequired,
        cancelUpgradeHandler: PropTypes.func.isRequired,
    }

    constructor() {
        super()

        this.submitHandler = this.submitHandler.bind(this)
        this.cancelHandler = this.cancelHandler.bind(this)
    }

    submitHandler() {
        const { id, level } = this.props.building
        this.props.upgradeBuilding(id, level + 1)
    }

    cancelHandler() {
        this.props.cancelUpgradeHandler()
    }

    render() {
        const { type, level } = this.props.building

        return (
            <UpgradeConfirmationView
                type={type}
                name={BUILDING_TITLES[type]}
                level={level}
                upgraded={this.props.upgraded}
                upgradeCost={this.props.upgradeCost}
                submitHandler={this.submitHandler}
                cancelHandler={this.cancelHandler}
            />
        )
    }
}

export const mapStateToProps = (state, { building }) => {
    const { settings, buildingUpgrade } = state

    return {
        building,
        upgradeCost: settings.buildings[building.type].costs[building.level],
        upgraded: buildingUpgrade.submitted,
    }
}

const mapDispatchToProps = {
    upgradeBuilding,
    cancelUpgradeHandler: closeUpgradeConfirmation,
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeConfirmation)



// WEBPACK FOOTER //
// ./containers/BuildingCard/components/UpgradeConfirmation/UpgradeConfirmation.jsx